/* ──────────────────────────────────────────────────────────────
   SILAMP : Carrousels produits v1.1 (Produits similaires + bloc Pro+)
   - Ajout rapide → stepper (− n +) synchronisé avec le panier (clé de ligne)
   - Multi-variantes → panneau d'options plein carte, option choisie rappelée au-dessus du stepper
   - Mini-cart Focal rafraîchi (même routine que silamp-product-addons)
   - HT/TTC : toggle global Silamp (#priceToggle, localStorage priceToggleState, window.updatePrices)
   ────────────────────────────────────────────────────────────── */
(function () {
  if (window.__slCarousel) { window.__slCarousel.init(); return; }

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var URL_ADD = ROOT + 'cart/add.js';
  var URL_CHANGE = ROOT + 'cart/change.js';
  var URL_CART = ROOT + 'cart.js';
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' };

  var cartMap = {};   // variantId -> { key, qty }
  var selfUntil = 0;  // ignore nos propres événements panier

  var ADD_HTML = '<button type="button" class="sl-sim-btn sl-sim-btn--add"><span aria-hidden="true">+</span> Ajouter</button>';
  var CHOOSE_HTML = '<button type="button" class="sl-sim-btn sl-sim-btn--choose">Choisir une option</button>';
  var CHEVRON = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6l4 4 4-4"/></svg>';
  var ARROW = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3l5 5-5 5"/></svg>';

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ── HT / TTC : on réutilise updatePrices() du thème (il ajoute lui-même « HT ») ── */
  function isTTC() {
    var s = null;
    try { s = localStorage.getItem('priceToggleState'); } catch (e) {}
    return s === null ? true : s === 'true';
  }
  function applyTax() {
    if (typeof window.updatePrices === 'function') window.updatePrices(isTTC());
  }
  /* ── Markup CTA ── */
  function cardOf(el) { return el.closest('.sl-sim-card'); }
  function slotOf(cta) { return cta.querySelector('.sl-sim-cta__slot'); }
  function labelFor(card, vid) {
    var o = card ? card.querySelector('.sl-sim-option[data-variant-id="' + vid + '"]') : null;
    return o ? o.getAttribute('data-label') : '';
  }
  function stepperHtml(q, label) {
    return (label ? '<button type="button" class="sl-sim-chosen" title="Changer d\u2019option"><span>' + esc(label) + '</span>' + CHEVRON + '</button>' : '')
      + '<div class="sl-sim-stepper">'
      + '<button type="button" class="sl-sim-step" data-step="-1" aria-label="Diminuer">\u2212</button>'
      + '<input type="text" class="sl-sim-qty" inputmode="numeric" value="' + q + '" aria-label="Quantit\u00e9">'
      + '<button type="button" class="sl-sim-step" data-step="1" aria-label="Augmenter">+</button>'
      + '</div>';
  }
  function showStepper(cta, vid, q) {
    var slot = slotOf(cta);
    var input = slot.querySelector('.sl-sim-qty');
    var label = cta.hasAttribute('data-has-options') ? labelFor(cardOf(cta), vid) : '';
    var chosen = slot.querySelector('.sl-sim-chosen span');
    if (input && (!label || (chosen && chosen.textContent === label))) {
      if (document.activeElement !== input) input.value = q;
    } else {
      slot.innerHTML = stepperHtml(q, label);
    }
    markCurrent(cardOf(cta), vid);
  }
  function resetSlot(cta) {
    if (cta.hasAttribute('data-has-options')) {
      slotOf(cta).innerHTML = CHOOSE_HTML;
      cta.removeAttribute('data-variant-id');
      markCurrent(cardOf(cta), null);
    } else {
      slotOf(cta).innerHTML = ADD_HTML;
    }
  }
  function markCurrent(card, vid) {
    if (!card) return;
    card.querySelectorAll('.sl-sim-option').forEach(function (o) {
      o.classList.toggle('is-current', !!vid && o.getAttribute('data-variant-id') === String(vid));
    });
  }

  /* ── Panneau d'options ── */
  function closeOptions(card) {
    var ov = card && card.querySelector('.sl-sim-options');
    if (ov) ov.hidden = true;
    if (card) card.classList.remove('is-choosing');
  }
  function closeAllOptions(except) {
    document.querySelectorAll('.sl-sim-card.is-choosing').forEach(function (c) { if (c !== except) closeOptions(c); });
  }
  function toggleOptions(card) {
    var ov = card.querySelector('.sl-sim-options');
    if (!ov) return;
    var willOpen = ov.hidden;
    closeAllOptions(card);
    ov.hidden = !willOpen;
    card.classList.toggle('is-choosing', willOpen);
    if (willOpen) {
      var first = ov.querySelector('.sl-sim-option.is-current') || ov.querySelector('.sl-sim-option:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }
  }

  /* ── Mini-cart Focal (routine silamp-product-addons) ── */
  async function refreshThemeCart(open) {
    selfUntil = Date.now() + 1500;
    var cartData = null;
    try {
      var r = await fetch(URL_CART, { headers: { 'Accept': 'application/json' } });
      if (r.ok) cartData = await r.json();
    } catch (e) {}
    if (cartData && typeof cartData.item_count === 'number') {
      document.querySelectorAll('cart-count, .header__cart-count, [data-cart-count]').forEach(function (el) {
        el.textContent = cartData.item_count;
        el.setAttribute('count', cartData.item_count);
      });
    }
    try {
      var s = await fetch(ROOT + '?sections=mini-cart');
      if (s.ok) {
        var sections = await s.json();
        if (sections['mini-cart']) {
          var doc = new DOMParser().parseFromString(sections['mini-cart'], 'text/html');
          var fresh = doc.querySelector('mini-cart, cart-drawer, [class*="mini-cart"]');
          var current = document.querySelector('mini-cart, cart-drawer, [class*="mini-cart"]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
      }
    } catch (e) {}
    document.documentElement.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    applyTax(); // le mini-cart réinjecté repasse sur le bon mode HT/TTC
    if (!open) return;
    setTimeout(function () {
      var mc = document.querySelector('mini-cart, cart-drawer');
      if (mc && typeof mc.open === 'function') { mc.open(); return; }
      var t = document.querySelector('[aria-controls*="mini-cart"], [aria-controls*="cart-drawer"], [data-action="open-mini-cart"]');
      if (t) t.click();
    }, 150);
  }

  /* ── Synchro panier ── */
  function refreshCartMap() {
    return fetch(URL_CART, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartMap = {};
        cart.items.forEach(function (it) {
          if (cartMap[it.variant_id]) cartMap[it.variant_id].qty += it.quantity;
          else cartMap[it.variant_id] = { key: it.key, qty: it.quantity };
        });
        return cart;
      })
      .catch(function () { return null; });
  }
  function syncCtas() {
    document.querySelectorAll('[data-sl-carousel] .sl-sim-cta').forEach(function (cta) {
      var slot = slotOf(cta);
      if (!slot) return;
      var card = cardOf(cta);
      var vid = cta.getAttribute('data-variant-id');
      if (cta.hasAttribute('data-has-options') && !(vid && cartMap[vid])) {
        vid = null;
        var opts = card.querySelectorAll('.sl-sim-option[data-variant-id]');
        for (var i = 0; i < opts.length; i++) {
          var ov = opts[i].getAttribute('data-variant-id');
          if (cartMap[ov] && cartMap[ov].qty > 0) { vid = ov; cta.setAttribute('data-variant-id', vid); break; }
        }
        if (!vid) { if (!slot.querySelector('.sl-sim-btn--choose')) resetSlot(cta); return; }
      }
      if (!vid) return;
      var q = cartMap[vid] ? cartMap[vid].qty : 0;
      if (q > 0) showStepper(cta, vid, q);
      else if (!slot.querySelector('.sl-sim-btn--add, .sl-sim-btn--choose')) resetSlot(cta);
    });
  }

  /* ── Ajout / quantité ── */
  function quickAdd(vid, cta) {
    cta.classList.add('is-loading');
    fetch(URL_ADD, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (res) {
        var item = res && res.items ? res.items[0] : res;
        var prev = cartMap[vid] || {};
        var qty = item && item.quantity ? item.quantity : (prev.qty || 0) + 1;
        cartMap[vid] = { key: (item && item.key) || prev.key || null, qty: qty };
        cta.setAttribute('data-variant-id', vid);
        cta.classList.remove('is-loading');
        showStepper(cta, vid, qty);
        refreshThemeCart(true);
      })
      .catch(function () { cta.classList.remove('is-loading'); });
  }
  function changeQty(vid, qty, cta) {
    if (!vid) return;
    if (qty < 0) qty = 0;
    if (!cartMap[vid] || !cartMap[vid].key) {
      cta.classList.add('is-loading');
      refreshCartMap().then(function () { doChange(vid, qty, cta); });
      return;
    }
    doChange(vid, qty, cta);
  }
  function doChange(vid, qty, cta) {
    var entry = cartMap[vid];
    if (!entry || !entry.key) { cta.classList.remove('is-loading'); syncCtas(); return; }
    cta.classList.add('is-loading');
    fetch(URL_CHANGE, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: entry.key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var q = 0, key = null;
        (cart.items || []).forEach(function (it) {
          if (String(it.variant_id) === String(vid)) { q += it.quantity; if (!key) key = it.key; }
        });
        cta.classList.remove('is-loading');
        if (q > 0) { cartMap[vid] = { key: key, qty: q }; showStepper(cta, vid, q); }
        else { delete cartMap[vid]; resetSlot(cta); }
        refreshThemeCart(false);
      })
      .catch(function () { cta.classList.remove('is-loading'); });
  }

  /* ── Interactions (délégation globale, une seule fois) ── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var card = t.closest('[data-sl-carousel] .sl-sim-card');
        if (!card) { closeAllOptions(null); return; }
    closeAllOptions(card);
    var b;

    if ((b = t.closest('.sl-sim-btn--choose, .sl-sim-chosen'))) { e.preventDefault(); toggleOptions(card); return; }
    if ((b = t.closest('.sl-sim-options__close'))) { e.preventDefault(); closeOptions(card); return; }
    if ((b = t.closest('.sl-sim-option'))) {
      e.preventDefault();
      if (b.disabled) return;
      closeOptions(card);
      var ctaO = card.querySelector('.sl-sim-cta');
      var vidO = b.getAttribute('data-variant-id');
      if (cartMap[vidO] && cartMap[vidO].qty > 0) { ctaO.setAttribute('data-variant-id', vidO); showStepper(ctaO, vidO, cartMap[vidO].qty); }
      else quickAdd(vidO, ctaO);
      return;
    }
    if (t.closest('.sl-sim-options')) return;

    if ((b = t.closest('.sl-sim-btn--add'))) {
      e.preventDefault();
      var ctaA = b.closest('.sl-sim-cta');
      if (ctaA.dataset.variantId) quickAdd(ctaA.dataset.variantId, ctaA);
      return;
    }
    if ((b = t.closest('.sl-sim-step'))) {
      e.preventDefault();
      var ctaS = b.closest('.sl-sim-cta');
      var inp = ctaS.querySelector('.sl-sim-qty');
      var cur = inp ? (parseInt(inp.value, 10) || 0) : 0;
      changeQty(ctaS.dataset.variantId, cur + parseInt(b.dataset.step, 10), ctaS);
    }
  });

  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-sl-carousel] .sl-sim-qty');
    if (!inp) return;
    var n = parseInt(inp.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    var cta = inp.closest('.sl-sim-cta');
    changeQty(cta.dataset.variantId, n, cta);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllOptions(null);
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('sl-sim-qty')) e.target.blur();
  });



  /* Re-sync quand le panier change ailleurs (formulaire produit, mini-cart...) */
  var resyncTimer = null;
  function resync() {
    if (Date.now() < selfUntil) return;
    clearTimeout(resyncTimer);
    resyncTimer = setTimeout(function () { refreshCartMap().then(syncCtas); }, 300);
  }
  ['cart:updated', 'cart:refresh', 'cart:added', 'variant:added', 'theme:cart:added'].forEach(function (ev) {
    document.addEventListener(ev, resync);
  });

  /* ── Carrousel ── */
  function initCarousel(root) {
    if (root.dataset.slReady) return;
    root.dataset.slReady = '1';
    var wrap = root.querySelector('.sl-sim__carousel');
    var track = root.querySelector('[data-sl-track]');
    if (!wrap || !track) return;

    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'sl-sim__arrow sl-sim__arrow--prev'; prev.setAttribute('aria-label', 'Pr\u00e9c\u00e9dent'); prev.hidden = true; prev.innerHTML = ARROW;
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'sl-sim__arrow sl-sim__arrow--next'; next.setAttribute('aria-label', 'Suivant'); next.hidden = true; next.innerHTML = ARROW;
    wrap.insertBefore(prev, track);
    wrap.appendChild(next);

    function stepPx() {
      var c = track.querySelector('.sl-sim-card');
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 14;
      var w = c ? c.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      return w * Math.max(1, Math.floor(track.clientWidth / w));
    }
    function update() {
      var overflow = track.scrollWidth > track.clientWidth + 2;
      prev.hidden = !overflow || track.scrollLeft <= 1;
      next.hidden = !overflow || track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    }
    prev.addEventListener('click', function () { closeAllOptions(null); track.scrollBy({ left: -stepPx(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { closeAllOptions(null); track.scrollBy({ left: stepPx(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 400);
  }

  function init() {
    var roots = document.querySelectorAll('[data-sl-carousel]');
    if (!roots.length) return;
    roots.forEach(initCarousel);
    applyTax();
    refreshCartMap().then(syncCtas);
  }

  window.__slCarousel = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);           // éditeur de thème
})();